export default [
  '$compile',
  function floatLabelText($compile) {
    return {
      restrict: 'A',
      scope: true,
      require: 'ngModel',
      link: (scope, el, attrs, ngModel) => {
        scope.$watch(function() {
          return ngModel.$modelValue;
        }, function(newValue) {
          if (newValue) {
            scope.hasSelectValue = true;
          } else {
            scope.hasSelectValue = false;
          }
        });

        let templateAttributes = [],
          smallSize = false;
        for (let attr in attrs) {
          if (attrs.hasOwnProperty(attr) && attr.substr(0, 1) !== '$' && attr !== 'floatLabelSelect' && attr !== 'placeholder') {
            templateAttributes.push(attrs.$attr[attr] + '="' + attrs[attr] + '"');
            if(attr === 'smallSize') smallSize = true;
          }
        }

        let template = `
          <div class="vs-input${smallSize ? ' small' : ''}" ng-class="{filled: hasSelectValue}">
            <label for="select_${scope.$id}" class="placeholder">${attrs.placeholder}</label>
            <span class="icons icons-arrow-bottom"></span>
            <div class="vs-input-bg"></div>
            <select id="select_${scope.$id}" class="form-control" ${templateAttributes.join(' ')}></select>
          </div>
        `;
        let linkFn = $compile(template);
        let content = linkFn(scope);
        el.replaceWith(content);
      }
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/float-labels/float-label-select.dir.js